import { useCallback, useEffect, useState } from "react";

import expenseService from "../services/expenseService";

import notify from "../../../services/notify";

const useExpenseCategories = () => {

    const [categories, setCategories] = useState([]);

    const [loading, setLoading] = useState(true);

    const [error, setError] = useState(null);

    //----------------------------------------------------

    const loadCategories = useCallback(async () => {

        try {

            setLoading(true);

            setError(null);

            const result = await expenseService.getExpenseCategories();

            setCategories(result ?? []);

        }

        catch (err) {

            console.error(err);

            setError(err);

            notify.error(err);

        }

        finally {

            setLoading(false);

        }

    }, []);

    //----------------------------------------------------

    useEffect(() => {

        loadCategories();

    }, [loadCategories]);

    //----------------------------------------------------

    return {

        categories,

        loading,

        error,

        refresh: loadCategories,

    };

};

export default useExpenseCategories;